// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-down"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 13.6L12 19.1L6.5 13.6M12 17.85V4.85","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-down',
    ref,
    icon: element,
  },
));

ArrowDownIcon.displayName = 'ArrowDownIcon';

export default ArrowDownIcon;
